import Page from '../../../shared/components/Page/Page';
import {Button, Form, message, Space, Table, Tag, Select, DatePicker} from "antd";
import {formatDateTime, numberFormat} from "../../../shared/utils/helpers";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdd} from "@fortawesome/free-solid-svg-icons";
import FormDrawer from "../../../shared/components/FormDrawer/FormDrawer";
import {useContext, useEffect, useState} from "react";
import { getBankWithdraw } from "../api";
import LoadingContext from "../../../app/contexts/LoadingContext";
import { createWithdrawal } from "../api";
import { getWithdrawals } from "../api";
import TextCopy from "../../../shared/components/TextCopy";
import dayjs from "dayjs";
import { SearchOutlined } from '@ant-design/icons';
function Withdraw() {
    const [searchForm] = Form.useForm();
    const [formWithdraw] = Form.useForm();
    const [open,setOpen] = useState(false);
    const [banks,setBanks] = useState([]);
    const {setLoading} = useContext(LoadingContext);
    const [, contextHolder] = message.useMessage();
    const [dataSource,setDataSource] = useState([]);
    const [tableLoading,setTableLoading] = useState(false);
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        search: {
            createdAt: [dayjs().startOf('day'), dayjs().endOf('day')]
        }
    });
    const statusOptions = [
        { label: 'Tất cả', value: '' },
        { label: 'Chờ duyệt', value: 'pending' },
        { label: 'Đã duyệt', value: 'processed' },
        { label: 'Bị từ chối', value: 'refused' }
    ];
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            align: 'center',
            sorter: true
        },
        {
            title: 'Ngân hàng',
            dataIndex: 'bankName'
        },
        {
            title: 'Số tài khoản',
            dataIndex: 'accountNumber',
            align: 'center',
            render: (value) => {
                return (
                    <TextCopy value={value}/>
                )
            }
        },
        {
            title: 'Tên tài khoản',
            dataIndex: 'accountName',
            align: 'center',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Số tiền',
            dataIndex: 'amount',
            sorter: true,
            align: 'center',
            render: (value) => {
                return numberFormat(value);
            }
        },
        {
            title: 'Ghi chú',
            dataIndex: 'note',
            width: '200px',
            align: 'center'
        },
        {
            title: 'Trạng thái',
            dataIndex: 'state',
            align: 'center',
            filters: [
                {
                    text: 'Chờ duyệt',
                    value: 'pending'
                },
                {
                    text: 'Đã duyệt',
                    value: 'processed'
                },
                {
                    text: 'Bị từ chối',
                    value: 'refused'
                }
            ],
            render: (value) => {
                if (value === 'pending') {
                    return <Tag color={'yellow'}>Chờ duyệt</Tag>
                }
                else if (value === "processed") {
                    return <Tag color={'green'}>Đã duyệt</Tag>
                }
                else if (value === "refused") {
                    return <Tag color={'red'}>Bị từ chối</Tag>
                }
            }
        },
        {
            title: 'Thời gian tạo',
            dataIndex: 'createdAt',
            sorter: true,
            render: (value) => {
                return formatDateTime(value)
            }
        }
    ]
    const itemWithdraws = [
        {
            name: 'accountNumber',
            placeholder: 'Nhập số tài khoản',
            type: 'text',
            label: 'Số tài khoản',
            required: true
        },
        {
            name: 'accountName',
            placeholder: 'Nhập tên tài khoản',
            type: 'text',
            label: 'Tên tài khoản',
            required: true
        },
        {
            name: 'amount',
            placeholder: 'Nhập số tiền',
            type: 'number',
            label: 'Số tiền',
            required: true
        },
        {
            name: 'bankCode',
            placeholder: 'Chọn ngân hàng',
            type: 'select',
            label: 'Ngân hàng nhận',
            required: true,
            options: (banks || []).map((item) => {
                return {
                    value: item.bankCode,
                    label: `${item.bankName} - ${item.displayName} (${item.shortName})`
                }
            })
        },
        {
            name: 'note',
            placeholder: 'Nhập ghi chú',
            type: 'text',
            label: 'Ghi chú',
            required: false
        },
    ]
    const handleSubmitWithdraw = (values) => {
        setLoading(true);
        const postData = async () => {
            const response = await createWithdrawal(values);
            if (!response.success) {
                message.open({
                    type: 'error',
                    content: response.message
                });
                return;
            }
            fetchDataTable();
        }
        postData().finally(()=> {
            setLoading(false);
        });
    }
    const fetchDataTable = async () => {
        setTableLoading(true);
        const response = await getWithdrawals(tableParams);
        if (response.success) {
            setDataSource(response.data.data);
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: response.data.total
                },
            });
        }
        setTableLoading(false);
    }
    const handleSearch = () => {
        const values = searchForm.getFieldsValue();
        const searchValues = {};
        
        if (values.dateRange) {
            searchValues.createdAt = values.dateRange;
        }
        
        if (values.state !== undefined && values.state !== '') {
            searchValues.state = values.state;
        }
        setTableParams({
            ...tableParams,
            search: searchValues
        });
    };
    const handleReset = () => {
        searchForm.resetFields();
        const emptySearchValues = {
            createdAt: [dayjs().startOf('day'), dayjs().endOf('day')]
        };
        setTableParams({
            ...tableParams,
            search: emptySearchValues
        });
    };
    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            ...tableParams,
            pagination,
            filters,
            sorter,
        });
    };
    useEffect(() => {
        const fetchData = async () => {
            const response = await getBankWithdraw();
            if (response.success) {
                setBanks(response.data);
            }
        }
        fetchData();
    }, []);
    useEffect(() => {
        fetchDataTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        tableParams?.sorter,
        tableParams?.search,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.filters),
    ])
    return (
        <Page title="Rút số dư">
            {contextHolder}
            <div style={{
                padding: '24px',
                background: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
            }}>
                <div style={{
                    marginBottom: '24px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <Button 
                        type="primary" 
                        ghost={true} 
                        onClick={() => setOpen(true)} 
                        style={{
                            height: '40px',
                            padding: '0 20px',
                            fontWeight: 500,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                    >
                        <FontAwesomeIcon icon={faAdd} style={{ fontSize: '14px' }}/>
                        Tạo đơn rút
                    </Button>
                </div>
                <div style={{
                    marginBottom: '24px',
                    padding: '16px',
                    background: '#f7f9fc',
                    borderRadius: '6px'
                }}>
                    <Form
                        form={searchForm}
                        layout="horizontal"
                        onFinish={handleSearch}
                        style={{ marginBottom: '24px' }}
                        initialValues={{
                            dateRange: [dayjs().startOf('day'), dayjs().endOf('day')]
                        }}
                    >
                        <Space wrap style={{ width: '100%', justifyContent: 'flex-start', gap: '16px' }}>
                            <Form.Item name="state" style={{ marginBottom: 0 }}>
                                <Select
                                    options={statusOptions}
                                    placeholder="Trạng thái"
                                    style={{ width: '150px' }}
                                    allowClear
                                />
                            </Form.Item>
                            <Form.Item name="dateRange" style={{ marginBottom: 0 }}>
                                <DatePicker.RangePicker
                                    style={{ width: '300px' }}
                                    placeholder={['Từ ngày', 'Đến ngày']}
                                />
                            </Form.Item>
                            <Form.Item style={{ marginBottom: 0 }}>
                                <Space>
                                    <Button 
                                        type="primary" 
                                        htmlType="submit" 
                                        icon={<SearchOutlined />}
                                    >
                                        Tìm kiếm
                                    </Button>
                                    <Button onClick={handleReset}>Đặt lại</Button>
                                </Space>
                            </Form.Item>
                        </Space>
                    </Form>
                </div>
                <Table
                    rowKey={'id'}
                    columns={columns}
                    dataSource={dataSource}
                    bordered={true}
                    scroll={{
                        x: 1800,
                    }}
                    loading={tableLoading}
                    pagination={{
                        ...tableParams.pagination,
                        showSizeChanger: true,
                        showTotal: (total) => `Tổng ${total} bản ghi`,
                        position: ['bottomRight']
                    }}
                    onChange={handleTableChange}
                    className="withdraw-table"
                    style={{
                        '.ant-table-thead > tr > th': {
                            background: '#f7f9fc',
                            fontWeight: 600
                        },
                        '.ant-table-tbody > tr:hover > td': {
                            background: '#f5f8ff'
                        },
                        '.ant-tag': {
                            minWidth: '80px',
                            textAlign: 'center',
                            fontWeight: 500
                        }
                    }}
                />
                
                <FormDrawer
                    form={formWithdraw}
                    open={open}
                    onClose={() => setOpen(false)}
                    items={itemWithdraws}
                    onSubmit={handleSubmitWithdraw}
                    title={'Tạo đơn rút tiền'}
                />
            </div>
        </Page>
    )
}
export default Withdraw;